import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ButtonIconGhostMedium from '../../../../components/common/ButtonIconGhost/ButtonIconGhostMedium';
import RightMenuDesign from '../../../../components/house/RightMenuDesign/RightMenuDesign';
import { Icon } from '../../../../components/icon/icon';
import { fetchLiftSupport } from '../../../../store/actions/liftSupport.action';
import { Collapse } from 'antd';
import { getValueFromString } from '../../../../utils/data/getValue.utils';
import CardProduct from '../../../../components/card/CardProduct/CardProduct';
import { useTranslation } from 'react-i18next';

const RightLiftSupportDesignMenu = ({ open, onClose, title, onClickCard }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { liftSupport } = useSelector(state => state.liftSupport);

  // const [searchParams] = useSearchParams();
  // const productType = searchParams.get("product_type") || "";

  // useEffect(() => {
  //   dispatch(fetchLiftSupport());
  // }, []);

  return (
    <>
      <RightMenuDesign
        open={open}
        classNames={{ root: 'top-84', content: 'flex flex-col !p-0 gap-0' }}
        header={
          <div className="flex self-stretch items-center justify-start gap-8">
            <ButtonIconGhostMedium
              icon={<Icon.ICArrowBack />}
              onClick={onClose}
            />
            <span className="text-title-large">{title}</span>
          </div>
        }
        content={
          <>
            <div className="flex p-8 justify-start items-start gap-2 self-stretch flex-wrap overflow-auto">
              {/* {listHandle.map((md, i) => { */}
              {/* {liftSupport?.data?.handles?.map((md, i) => {
                const name = getValueFromString(md.name);
                const description = getValueFromString(md.description);
                return (
                  <CardProductClick
                    key={i}
                    md={md}
                    title={name}
                    description1={description}
                    description2={md.size}
                    // description2={
                    //   <span className="text-body-small-emphasized font-semibold">
                    //     {md.price.toLocaleString('vi-VN', {
                    //       style: 'currency',
                    //       currency: 'VND',
                    //     })}
                    //   </span>
                    // }
                    moduleType={'moduleType'}
                    onClick={onClickCard}
                  />
                );
              })} */}
              <Collapse
                expandIcon={({ isActive }) => (
                  <span className="w-16 h-16 flex">
                    {isActive ? <Icon.ICExpandMore /> : <Icon.ICExpandLess />}
                  </span>
                )}
                defaultActiveKey={['1', '2', '3']}
                onChange={() => {}}
                className="grow overflow-auto flex self-stretch"
                items={[
                  {
                    key: '1',
                    label: (
                      <span className="text-title-medium">
                        {t('Single door')}
                      </span>
                    ),
                    children: (
                      <div className="grid !p-0 items-start align-content-start gap-2 grow self-stretch grid-cols-2">
                        {liftSupport?.data?.default_lifts?.['1canh']?.map(
                          (md, i) => {
                            // {listDoor.map((md, i) => {
                            const name = getValueFromString(md.name);
                            const description = getValueFromString(
                              md.description ?? ''
                            );

                            return (
                              <CardProduct
                                key={i}
                                md={md}
                                title={name}
                                description1={description}
                                description2={md.size}
                                moduleType={i}
                                // onDragStart={onDragStart}
                              />
                            );
                          }
                        )}
                      </div>
                    ),
                  },
                  {
                    key: '2',
                    label: (
                      <span className="text-title-medium">
                        {t('Double Door')}
                      </span>
                    ),
                    children: (
                      <div className="grid !p-0 items-start align-content-start gap-2 grow self-stretch grid-cols-2">
                        {liftSupport?.data?.default_lifts?.['2canh']?.map(
                          (md, i) => {
                            // {listDoor45.map((md, i) => {
                            const name = getValueFromString(md.name);
                            const description = getValueFromString(
                              md.description ?? ''
                            );

                            return (
                              <CardProduct
                                key={i}
                                md={md}
                                title={name}
                                description1={description}
                                description2={md.size}
                                moduleType={i}
                                // onDragStart={onDragStart}
                              />
                            );
                          }
                        )}
                      </div>
                    ),
                  },
                ].map(item => ({
                  ...item,
                  onKeyDown: e => {
                    e.stopPropagation();
                  },
                }))}
              />
            </div>
          </>
        }
      />
    </>
  );
};

export default RightLiftSupportDesignMenu;
